import TitleBar9 from './titleBar9';
export default TitleBar9;
